import { subDays } from "date-fns";

const numberOfDaysInThePastForDeploymentDate = 21;

/**
 * this function looks to see if a deployment's date is further in the past than
 * numberOfDaysInThePastForDeployementDate
 * @param {Map} deployment
 * @returns bool
 */
export function isDeploymentDateOutdated(deployment) {
	const deploymentDate = new Date(deployment.getIn(["log", "deployedDate"], ""));
	const expiringDate = subDays(new Date(), numberOfDaysInThePastForDeploymentDate);

	return expiringDate > deploymentDate;
}
